import { makeVar } from '@apollo/client';

export const searchString = makeVar('');
